module.exports = __webpack_public_path__ + "static/yellow_musk_zombie-924f7a3076bcec938dd2c9815fad477e.png";